import { Form, type FormInstance, Input, Select } from 'antd';
import { isEmpty } from 'lodash';
import type React from 'react';
import { FINAL_RATING_OPTIONS } from '../../../../../common/constants';
import type { SexuallyInappropriateAnalysesData } from '../SexuallyInappropriateAnalyses';

const { TextArea } = Input;

const RatingSummaryForm: React.FC<{
  form: FormInstance;
  setIsSubmitBtnDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  selectSexuallyInappropriateData:
    | SexuallyInappropriateAnalysesData
    | undefined;
}> = ({ form, setIsSubmitBtnDisabled, selectSexuallyInappropriateData }) => {
  const feedbackData = selectSexuallyInappropriateData?.subSection?.feedback;
  return (
    <Form
      layout="vertical"
      form={form}
      className="signal-detection-form-grid"
      initialValues={{}}
      onValuesChange={() => setIsSubmitBtnDisabled(false)}
    >
      <div className="signal-detection-form-item signal-detection-form-item">
        <Form.Item
          label="Final Rating"
          name="sexuallyFinalRating"
          className={
            feedbackData?.sexuallyFinalRating !== undefined &&
            selectSexuallyInappropriateData?.finalRating !== undefined
              ? 'signal-detection-form-item--with-below-text'
              : 'signal-detection-form-item'
          }
        >
          <Select
            size="middle"
            options={FINAL_RATING_OPTIONS}
            placeholder="Select final rating"
          />
        </Form.Item>
        {feedbackData?.sexuallyFinalRating !== undefined &&
          selectSexuallyInappropriateData?.finalRating !== undefined && (
            <div className="signal-detection-below-text">
              <span className="font-w-600">Originally:</span>{' '}
              <span>{selectSexuallyInappropriateData?.finalRating}</span>
            </div>
          )}
      </div>
      <div className="signal-detection-form-item signal-detection-form-item">
        <Form.Item
          label="Rating Reason"
          name="sexuallyRatingReason"
          className={
            !!feedbackData?.sexuallyRatingReason &&
            !isEmpty(selectSexuallyInappropriateData?.ratingReason)
              ? 'signal-detection-form-item--with-below-text'
              : 'signal-detection-form-item'
          }
        >
          <TextArea
            className="reason-textarea"
            placeholder="Enter reason for rating"
            rows={6}
          />
        </Form.Item>
        {!!feedbackData?.sexuallyRatingReason &&
          !isEmpty(selectSexuallyInappropriateData?.ratingReason) && (
            <div className="signal-detection-below-text">
              <span className="font-w-600">Originally:</span>{' '}
              <span>{selectSexuallyInappropriateData?.ratingReason}</span>
            </div>
          )}
      </div>
    </Form>
  );
};

export default RatingSummaryForm;
